module.exports = __webpack_public_path__ + "assets/echeanceamount.799703da.svg";